import React from 'react';
import DataDrivenArticlePage from '../components/articles/DataDrivenArticlePage';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'Motor Control Unit (MCU) | AUTOXIUM';
const PAGE_DESCRIPTION =
  'A complete engineering guide to the EV Motor Control Unit (MCU) / traction inverter — hardware architecture, ' +
  'Field-Oriented Control (FOC), SVPWM, AUTOSAR software layers, functional safety (ISO 26262), cybersecurity ' +
  '(ISO 21434), diagnostics, and real vehicle examples for automotive and embedded engineers.';

const McuTractionInverterTechnicalArticlePage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);
  return <DataDrivenArticlePage slug="article-mcu-traction-inverter" pdfSlug="mcu-traction-inverter" />;
};

export default McuTractionInverterTechnicalArticlePage;
